import React from "react";
import cx from "classnames";
import { useField } from "formik";
import InputField from "./InputField";

const Textbox = ({
  className,
  containerClass,
  hint,
  label,
  required,
  ...props
}) => {
  const [field, meta] = useField(props);
  const isInvalid = Boolean(meta && meta.touched && meta.error);

  return (
    <InputField
      className={containerClass}
      hint={hint}
      id={props.id}
      label={label}
      meta={meta}
      name={props.name}
      required={required}
    >
      <input
        aria-invalid={isInvalid}
        // `aria-required` rather than the native `required`: validation is
        // Formik's, and the submit button lives outside this <form>.
        aria-required={required || undefined}
        className={cx("gkit-input-md", className, isInvalid && "gkit-invalid")}
        type="text"
        {...field}
        {...props}
      />
    </InputField>
  );
};

export default Textbox;
